const React = require("react")
const Cookies = require("js-cookie")

/*type DarkModeContextType = {
  isDarkMode: boolean
  toggleDarkMode: () => void
}*/

const DarkModeContext = React.createContext(undefined)//<DarkModeContextType | undefined>(undefined)

exports.DarkModeProvider = ({ children, initialValue }) => {
  const [isDarkMode, setIsDarkMode] = React.useState(false)
  
  const handleDarkMode = React.useCallback(() => {
    //e.preventDefault()
    setIsDarkMode(prev => !prev)
  }, [])



  /*const handleDarkMode = React.useCallback((e) => {
    const btn = e.target
		const html = document.documentElement
    
		if(btn.checked === true) {
			// html.classList.add('dark')
      //localStorage.theme = 'dark'//Cookies.set('darkMode', 'on')
      //document.documentElement.dataset.theme = "dark"
      setIsDarkMode(true)
		}else{
			//html.classList.remove('dark')
      //localStorage.removeItem('theme')//Cookies.remove('darkMode')
      //delete document.documentElement.dataset.theme
      setIsDarkMode(false)
		}

  }, [])*/

  //const [isFirstRender, setIsFirstRender] = React.useState(false)

  // 初回用
  React.useLayoutEffect(() => {
     // const html = document.documentElement
      //const isDark = html.classList.contains("dark")
      
      
      
      //if(localStorage.getItem('theme') === 'dark') {
        //console.log('isDarkはtrue')
        /*handle.checked = true
        html.classList.add('dark')
        localStorage.theme = 'dark'//Cookies.set('darkMode', 'on')
        document.documentElement.dataset.theme = "dark"*/
        

        setIsDarkMode(localStorage.getItem('theme') === 'dark' || window.matchMedia('(prefers-color-scheme: dark)').matches)
      }, [])

  React.useEffect(() => {
    const html = document.documentElement
    
    if(isDarkMode){
      //html.classList.remove('light-mode-theme')
      html.classList.add('dark')
      localStorage.setItem('theme', 'dark')//Cookies.set('darkMode', 'on')
      document.documentElement.dataset.theme = "dark"
      //setIsCookie(true)
    }else{
      html.classList.remove('dark')
      //html.classList.add('light-mode-theme')
      localStorage.removeItem('theme')//Cookies.remove('darkMode')
      delete document.documentElement.dataset.theme
      //setIsCookie(false)
    }
  }, [isDarkMode])



  React.useEffect(() => {
    console.log('addEventListener!')

		//setIsDarkMode(Cookies.get('darkMode') === 'on')

		const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
		//const darkModeOn = darkModeMediaQuery.matches

		const handler = (e) => {
			//console.log('dark-mode-media')
				setIsDarkMode(e.matches)
		}

		darkModeMediaQuery.addEventListener('change', handler)

		return () => {
			darkModeMediaQuery.removeEventListener('change', handler)
		}
  }, [])

  return (
    <DarkModeContext.Provider value={{ isDarkMode, handleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  )
}

exports.useDarkMode = () => {
  const ctx = React.useContext(DarkModeContext)
  if (!ctx) throw new Error("useDarkMode must be used inside DarkModeProvider")
  return ctx
}
